// The values double as the form field name each tracker posts under, so they are lower-cased where the
// other enums are not.
enum TrackerField {
    HitPoints = "hitPoints",
    MaxHitPoints = "maxHitPoints",
    ArmorPoints = "armorPoints",
    ExperiencePoints = "experiencePoints"
}
